import { render } from "./MyAccountVet.vue?vue&type=template&id=109ac8d2&scoped=true"
import script from "./MyAccountVet.vue?vue&type=script&lang=js"
export * from "./MyAccountVet.vue?vue&type=script&lang=js"

import "./MyAccountVet.vue?vue&type=style&index=0&id=109ac8d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109ac8d2"]])

export default __exports__